import OutgoingPaymentMethod from '../models/OutgoingPaymentMethod'

export const OutgoingPaymentMethodMixin = {
  data() {
    return {
      outgoing_payment_method: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new OutgoingPaymentMethod({
          country_id: undefined,
          type: undefined,
          instructions: '',
          bank_required: true,
          info_label1: undefined,
          info_label2: undefined,
          is_default: true,
      })
    }
  }
}
